import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { FileUploadModule } from 'ng2-file-upload';
import { CommonModule } from '@angular/common';
import { AlgButtonComponent } from './components/atoms/alg-button/alg-button.component';
import { AlgLogoComponent } from './components/atoms/alg-logo/alg-logo.component';
import { AlgIconComponent } from './components/atoms/alg-icon/alg-icon.component';
import { AlgInputComponent } from './components/atoms/alg-input/alg-input.component';
import { AlgGmapsInputComponent } from './components/atoms/alg-gmaps-input/alg-gmaps-input.component';
import { OtpCodeInputComponent } from './components/atoms/otp-code-input/otp-code-input.component';
import { AlgSwitchComponent } from './components/atoms/alg-switch/alg-switch.component';
import { AlgSelectComponent } from './components/atoms/alg-select/alg-select.component';
import { AlgRadioComponent } from './components/atoms/alg-radio/alg-radio.component';
import { AlgGenericCardComponent } from './components/molecules/alg-generic-card/alg-generic-card.component';
import { AlgInfoTooltipComponent } from './components/molecules/alg-info-tooltip/alg-info-tooltip.component';
import { AlgSelectedOfferComponent } from './components/molecules/alg-selected-offer/alg-selected-offer.component';
import { AlgAccordionComponent } from './components/molecules/alg-accordion/alg-accordion.component';
import { AlgMainContainerStep } from './components/molecules/alg-main-container-step/alg-main-container-step.component';
import { AlgAccordionHeaderComponent } from './components/molecules/alg-accordion-header/alg-accordion-header.component';
import { AlgTooltipContentComponent } from './components/molecules/alg-tooltip-content/alg-tooltip-content.component';
import { AlgInfoCardComponent } from './components/molecules/alg-info-card/alg-info-card.component';
import { AlgProgressBarComponent } from './components/atoms/alg-progress-bar/alg-progress-bar.component';
import { AlgDocumentNeededComponent } from './components/molecules/alg-document-needed/alg-document-needed.component';
import { AlgSuccessHeroComponent } from './components/molecules/alg-success-hero/alg-success-hero.component';
import { AlgSuccessInfoComponent } from './components/molecules/alg-success-info/alg-success-info.component';
import { AlgImageRadioComponent } from './components/molecules/alg-image-radio/alg-image-radio.component';
import { AlgPaymentRadioComponent } from './components/molecules/alg-payment-radio/alg-payment-radio.component';
import { AlgSummaryInfoBoxComponent } from './components/atoms/alg-summary-info-box/alg-summary-info-box.component';
import { AlgInpageNotificationComponent } from './components/atoms/alg-inpage-notification/alg-inpage-notification.component';
import { AlgNextStepsComponent } from './components/molecules/alg-next-steps/alg-next-steps.component';
import { AlgGasRadioComponent } from './components/molecules/alg-gas-radio/alg-gas-radio.component';
import { AlgCheckboxComponent } from './components/atoms/alg-checkbox/alg-checkbox.component';
import { AlgCheckbox2Component } from './components/atoms/alg-checkbox-2/alg-checkbox-2.component';
import { LoaderComponent } from './components/atoms/alg-loader/loader.component';
import { AlgFaceComponent } from './components/atoms/alg-face/alg-face.component';
import { AlgFaceGroupComponent } from './components/molecules/alg-face-group/alg-face-group.component';
import { AlgFeedbackComponent } from './components/molecules/alg-feedback/alg-feedback.component';
import { AlgFisicoPersonalDataComponent } from './components/molecules/alg-fisico-personal-data/alg-fisico-personal-data.component';
import { AlgScontoFormComponent } from './components/molecules/alg-sconto-form/alg-sconto-form.component';
import { AlgScontoHeaderComponent } from './components/molecules/alg-sconto-header/alg-sconto-header.component';
import { AlgScontoFooterComponent } from './components/molecules/alg-sconto-footer/alg-sconto-footer.component';
import { AlgScontoHeroComponent } from './components/molecules/alg-sconto-hero/alg-sconto-hero.component';
import { AlgErrorModalComponent } from './components/atoms/alg-error-modal/alg-error-modal.component';
import { AlgHeaderDetailsComponent } from './components/atoms/alg-header-details/alg-header-details.component';
import { AlgInput2Component } from './components/atoms/alg-input-2/alg-input-2.component';
import { AlgGenericSecondCardComponent } from './components/molecules/alg-generic-second-card/alg-generic-second-card.component';
import { AlgAssistanceComponent } from './components/molecules/alg-assistance/alg-assistance.component';
import { AlgSidebarComponent } from './components/alg-sidebar/alg-sidebar.component';
import { AlgCompleteComponent } from './components/steps/alg-complete/alg-complete.component';
import { AlgPrivacyAreaComponent } from './components/molecules/alg-privacy-area/alg-privacy-area.component';
import { AlgConsensoContractPhysicalHeroComponent } from './components/molecules/alg-consenso-contract-physical-hero/alg-consenso-contract-physical-hero.component';
import { AlgCoopMembershipCardComponent } from './components/molecules/alg-coop-membership-card/alg-coop-membership-card.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  L10nConfig,
  L10nLoader,
  TranslationModule,
  StorageStrategy,
  ProviderType,
} from 'angular-l10n';
import { ApiService } from './services/api.service';
import { AlgGtmService } from './services/alg-gtm.service';
import { UtilsService } from './services/utils.service';
import { AlgFisicoService } from './services/alg-fisico.service';
import { AlgPrivacyService } from './services/alg-privacy.service';
import { AlgScontoService } from './services/alg-sconto.service';
import { AlgAttivazioniService } from './services/alg-attivazioni.service';
// import { AlgSwitchFisicoPageComponent } from './pages/alg-switch-fisico-page/alg-switch-fisico-page.component';
import { AlgConsensoService } from './services/alg-consenso.service';
import { AlgListProgressComponent } from './components/atoms/alg-list-progress/alg-list-progress.component';
import { AlgOptionGasComponent } from './components/molecules/alg-option-gas/alg-option-gas.component';
import { AlgOptionLightComponent } from './components/molecules/alg-option-light/alg-option-light.component';
import { AlgLinearContractHeroComponent } from './components/molecules/alg-linear-contract-hero/alg-linear-contract-hero.component';
import { AlgAgileContractHeroComponent } from './components/molecules/alg-agile-contract-hero/alg-agile-contract-hero.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { AlgPdfModalComponent } from './components/dialogs/alg-pdf-modal/alg-pdf-modal.component';
import { AlgExitPopupComponent } from './components/dialogs/alg-exit-popup/alg-exit-popup.component';
const l10nConfig: L10nConfig = {
  locale: {
    languages: [{ code: 'it', dir: 'ltr' }],
    language: 'it',
    storage: StorageStrategy.Cookie,
  },
  translation: {
    providers: [
      {
        type: ProviderType.Static,
        prefix: './assets/locale-',
      },
    ],
    caching: true,
    missingValue: 'no key',
  },
};

@NgModule({
  imports: [
    CommonModule,
    GooglePlaceModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ModalDialogModule,
    NgSelectModule,
    FileUploadModule,
    TranslationModule.forRoot(l10nConfig),
    PdfJsViewerModule,
  ],
  declarations: [
    AlgButtonComponent,
    AlgLogoComponent,
    AlgIconComponent,
    AlgInputComponent,
    AlgGmapsInputComponent,
    OtpCodeInputComponent,
    AlgSwitchComponent,
    AlgSelectComponent,
    AlgRadioComponent,
    AlgGenericCardComponent,
    AlgInfoTooltipComponent,
    AlgSelectedOfferComponent,
    AlgAccordionComponent,
    AlgMainContainerStep,
    AlgAccordionHeaderComponent,
    AlgTooltipContentComponent,
    AlgInfoCardComponent,
    AlgProgressBarComponent,
    AlgDocumentNeededComponent,
    AlgSuccessHeroComponent,
    AlgSuccessInfoComponent,
    AlgImageRadioComponent,
    AlgPaymentRadioComponent,
    AlgSummaryInfoBoxComponent,
    AlgInpageNotificationComponent,
    AlgNextStepsComponent,
    AlgGasRadioComponent,
    AlgCheckboxComponent,
    AlgCheckbox2Component,
    LoaderComponent,
    AlgFaceComponent,
    AlgFaceGroupComponent,
    AlgFeedbackComponent,
    AlgFisicoPersonalDataComponent,
    AlgScontoFormComponent,
    AlgScontoHeaderComponent,
    AlgScontoFooterComponent,
    AlgScontoHeroComponent,
    AlgErrorModalComponent,
    AlgHeaderDetailsComponent,
    AlgInput2Component,
    AlgGenericSecondCardComponent,
    AlgAssistanceComponent,
    AlgSidebarComponent,
    AlgCompleteComponent,
    AlgPrivacyAreaComponent,
    AlgConsensoContractPhysicalHeroComponent,
    AlgCoopMembershipCardComponent,
    // AlgSwitchFisicoPageComponent,
    AlgListProgressComponent,
    AlgOptionGasComponent,
    AlgOptionLightComponent,
    AlgLinearContractHeroComponent,
    AlgAgileContractHeroComponent,
    AlgPdfModalComponent,
    AlgExitPopupComponent,
  ],
  entryComponents: [AlgPdfModalComponent, AlgExitPopupComponent],
  providers: [
    ApiService,
    AlgGtmService,
    UtilsService,
    AlgFisicoService,
    AlgConsensoService,
    AlgPrivacyService,
    AlgScontoService,
    AlgAttivazioniService,
  ],
  exports: [
    AlgButtonComponent,
    AlgLogoComponent,
    AlgIconComponent,
    AlgInputComponent,
    AlgGmapsInputComponent,
    OtpCodeInputComponent,
    AlgSwitchComponent,
    AlgSelectComponent,
    AlgRadioComponent,
    AlgGenericCardComponent,
    AlgInfoTooltipComponent,
    AlgSelectedOfferComponent,
    AlgAccordionComponent,
    AlgMainContainerStep,
    AlgAccordionHeaderComponent,
    AlgTooltipContentComponent,
    AlgInfoCardComponent,
    AlgProgressBarComponent,
    AlgDocumentNeededComponent,
    AlgSuccessHeroComponent,
    AlgSuccessInfoComponent,
    AlgImageRadioComponent,
    AlgPaymentRadioComponent,
    AlgSummaryInfoBoxComponent,
    AlgInpageNotificationComponent,
    AlgNextStepsComponent,
    AlgGasRadioComponent,
    AlgCheckboxComponent,
    AlgCheckbox2Component,
    LoaderComponent,
    AlgFaceComponent,
    AlgFaceGroupComponent,
    AlgFeedbackComponent,
    AlgFisicoPersonalDataComponent,
    AlgScontoFormComponent,
    AlgScontoHeaderComponent,
    AlgScontoFooterComponent,
    AlgScontoHeroComponent,
    AlgErrorModalComponent,
    AlgHeaderDetailsComponent,
    AlgInput2Component,
    AlgGenericSecondCardComponent,
    AlgAssistanceComponent,
    AlgSidebarComponent,
    AlgCompleteComponent,
    AlgPrivacyAreaComponent,
    AlgConsensoContractPhysicalHeroComponent,
    // AlgSwitchFisicoPageComponent,
    AlgCoopMembershipCardComponent,
    AlgListProgressComponent,
    AlgOptionGasComponent,
    AlgOptionLightComponent,
    AlgLinearContractHeroComponent,
    AlgAgileContractHeroComponent,
  ],
})
export class SharedModule {
  constructor(public l10nLoader: L10nLoader) {
    this.l10nLoader.load();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared.module.ts